import { observer } from 'mobx-react';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog, useIsUploadLocked } from '@roc/feature-general-tasks';
import { BankStatementDashboard } from './bankStatementDashboard';

export interface BorrowerLiquidityDialogProps {
  open: boolean;
  onClose: () => void;
  document?: Document;
}

export const BorrowerLiquidityDialog = observer(
  ({ open, onClose, document }: BorrowerLiquidityDialogProps) => {
    const uploadLocked = useIsUploadLocked(document?.status);

    return (
      <>
        {document?.taskId && (
          <CustomTaskDialog
            open={open}
            title="Borrower Liquidity"
            handleClose={onClose}
            taskId={document?.taskId}
            maxWidth="lg"
            allowVertScroll={false}
            dialogContent={
              <BankStatementDashboard
                loanId={document?.loanId}
                borrowerId={document?.borrowerId}
                hideUpload={uploadLocked}
              />
            }
          />
        )}
      </>
    );
  }
);
